export const DiscountNatures = {
  DISCOUNT: "DISCOUNT",
  GIFTCARD: "GIFTCARD",
  SALES: "SALES",
  REVIEW: "REVIEW",
  CREDIT: "CREDIT"
};
